'use strict';
module.exports = require('../../full/object/keys');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/keys.js
// module id = 610
// module chunks = 13